import { useEffect, useState } from 'react';

import FilterIcon from '@mui/icons-material/FilterList';
import { Typography, Grid, Box, Button } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { Element } from 'react-scroll';

import { CourseFilterDrawer } from '../../courseFilter';

import SortOrderFormControl from './sortOrderFormControl';
import Style from './style';

import { useWindowSize } from 'src/helpers/use';
import { numberWithCommas } from 'src/helpers/utils';

type Anchor = 'top' | 'left' | 'bottom' | 'right';

type Props = {
  numberOfCourse: number;
  showNumberOfCourse?: boolean;
  isSelectLearningPathCourse?: boolean;
};

const CourseResultHeader = ({ numberOfCourse, showNumberOfCourse = false, isSelectLearningPathCourse }: Props) => {
  const { width } = useWindowSize();
  const { t } = useTranslation('common');
  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const [alignItems, setAlignItems] = useState('center');
  const anchor: Anchor = 'right';

  const closeDrawer = () => {
    setState({ ...state, [anchor]: false });
  };

  const openDrawer = () => {
    setState({ ...state, [anchor]: true });
  };

  const CourseTotalText = () => <>{t('all_course.result.course_count', { total: numberWithCommas(numberOfCourse) })}</>;

  useEffect(() => {
    if (width && width > 1200 && state[anchor]) {
      setState({ ...state, [anchor]: false });
    }
    if (width && width < 576) {
      if (alignItems !== 'top') {
        setAlignItems('top');
      }
    } else if (alignItems !== 'center') {
      setAlignItems('center');
    }
  }, [width]);

  return (
    <Style container alignItems={alignItems}>
      <Element name="courseResultHeader" />
      <Grid item xs>
        <Box sx={{ display: { xs: 'block', lg: 'none' } }}>
          <Button variant="outlined" sx={{ mr: 1, height: '46px' }} onClick={openDrawer} startIcon={<FilterIcon />}>
            {t('all_course.filter.title')}
          </Button>
          <CourseFilterDrawer
            isOpen={state[anchor]}
            anchor={anchor}
            onClose={closeDrawer}
            isSelectLearningPathCourse={isSelectLearningPathCourse}
          />
          {showNumberOfCourse && (
            <>
              <Typography
                variant="h4"
                component="span"
                sx={{ display: { sm: 'inline', xs: 'none' } }}
                className="title"
              >
                <CourseTotalText />
              </Typography>
              <Typography
                variant="h4"
                component="div"
                sx={{ display: { sm: 'none', xs: 'block' }, mt: 2 }}
                className="title"
              >
                <CourseTotalText />
              </Typography>
            </>
          )}
        </Box>
        {showNumberOfCourse && (
          <Box sx={{ display: { xs: 'none', lg: 'block' } }}>
            <Typography variant="h4" component="div" className="title">
              <CourseTotalText />
            </Typography>
          </Box>
        )}
      </Grid>
      <Grid item xs>
        <Grid container justifyContent="flex-end">
          <SortOrderFormControl />
        </Grid>
      </Grid>
    </Style>
  );
};

export default CourseResultHeader;
